import React, { SVGAttributes } from "react";

import * as S from "./Icon.styles";

const DEFAULT_ICON_SIZE = 24;

export type IconProps = SVGAttributes<SVGSVGElement>;

export type WrappingIconProps = Omit<IconProps, "children">;

export const Icon = (props: IconProps) => (
  <S.Layout
    fill="currentcolor"
    viewBox="0 0 24 24"
    strokeWidth={0}
    width={DEFAULT_ICON_SIZE}
    height={DEFAULT_ICON_SIZE}
    // role="img" is the correct a11y pattern for an inline SVG; the suggested
    // <img> tag does not apply to inline SVG markup.
    // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  />
);

Icon.displayName = "Icon";
